import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const HeroSection = () => {
  const navigate = useNavigate();

  const handleStartJourney = () => {
    navigate('/registration-screen');
  };

  return (
    <section className="relative bg-gradient-to-br from-primary/5 via-background to-accent/5 py-20 md:py-32">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-grid-slate-900/[0.04] bg-[size:75px_75px]" />
      <div className="absolute inset-0 flex items-center justify-center opacity-5">
        <div className="text-[20rem] font-bold text-slate-600">AI</div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Header Navigation */}
          <div className="flex justify-between items-center mb-16">
            <div className="flex items-center space-x-2">
              <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center">
                <Icon name="Brain" size={20} className="text-white" />
              </div>
              <span className="text-xl font-semibold text-foreground">MycoMind</span>
            </div>
            <nav className="hidden md:flex items-center space-x-8">
              <a href="#what-we-do" className="text-muted-foreground hover:text-foreground transition-colors">
                Features
              </a>
              <a href="#how-it-works" className="text-muted-foreground hover:text-foreground transition-colors">
                How It Works
              </a>
              <a href="#who-its-for" className="text-muted-foreground hover:text-foreground transition-colors">
                For You
              </a>
              <Button 
                variant="outline" 
                size="sm"
                onClick={() => navigate('/login-screen')}
              >
                Sign In
              </Button>
            </nav>
          </div>

          {/* Hero Content */}
          <div className="space-y-8">
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-foreground leading-tight">
              Bridging the Gap Between{' '}
              <span className="text-primary">Patients</span>{' '}
              and{' '}
              <span className="text-accent">Providers</span>{' '}
              with AI
            </h1>
            
            <p className="text-xl md:text-2xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
              MycoMind transforms daily health data into actionable insights for personalized care.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-8">
              <Button
                size="xl"
                onClick={handleStartJourney}
                className="text-lg px-8 py-4 shadow-lg hover:shadow-xl transition-all duration-300"
                iconName="ArrowRight"
                iconPosition="right"
              >
                Start Your Journey
              </Button>
              <Button
                variant="outline"
                size="xl"
                onClick={() => navigate('/provider-dashboard')}
                className="text-lg px-8 py-4"
                iconName="Play"
                iconPosition="left"
              >
                Explore Demo
              </Button>
            </div>

            {/* Trust Indicators */}
            <div className="pt-12 border-t border-border/50 mt-16">
              <p className="text-sm text-muted-foreground mb-6">Trusted by healthcare professionals</p>
              <div className="flex items-center justify-center space-x-8 opacity-60">
                <div className="flex items-center space-x-2">
                  <Icon name="Shield" size={16} />
                  <span className="text-sm">HIPAA Compliant</span>
                </div>
                <div className="flex items-center space-x-2">
                  <Icon name="Lock" size={16} />
                  <span className="text-sm">End-to-End Encrypted</span>
                </div>
                <div className="flex items-center space-x-2">
                  <Icon name="Award" size={16} />
                  <span className="text-sm">FDA Cleared</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;